export default "__VITE_ASSET__9275a4a4__"